export default __webpack_public_path__ + "static/media/message_fail.e755c281.svg";